export type LanguageDefinition = {
  code: string
  flag: string
  description: string
}

export function getLanguageDefinition(code: string) {
  let lang = languages.find(l => l.code === code)
  if (!lang) lang = languages[0]
  return lang
}

export function getCurrentLanguage() {
  const lang = localStorage.getItem('i18nextLng')

  if (lang) {
    return lang
  } else {
    return 'en'
  }

}

const languages = [
  { code: 'en', flag: 'gb', description: 'English' },
  { code: 'de', flag: 'de', description: 'Deutsche' }
]

export default languages
